/**
 * Custom JS by RoarTheme Agent
 * https://haloroar.ticksy.com/submit/#100022045
 * App: RT: Terms and Conditions Box
 */
document.addEventListener("DOMContentLoaded", () => {
  const configuration = {
    widgetSelector: ".rale-widget",
    links: {
      link: "link",
      link1: "link-1786881056536",
      link2: "link-1786881064640",
    },
  };

  const legalConfig = window?.roarJs?.LegalConfig?.metafields?.settings;
  if (!legalConfig || legalConfig.enabled !== "1") return;

  const { param } = legalConfig;
  if (!param || !param.links) return;

  const messageKey = "message";
  const errorKey = "error_message";

  const translations = {
    en: {
      [messageKey]: `I have read, understood and agree to the {${configuration.links.link}}, {${configuration.links.link1}} and {${configuration.links.link2}}. `,
      [errorKey]:
        "Please agree to the terms and conditions before making a purchase!",
      labels: {
        [configuration.links.link]: "Preliminary Information Form",
        [configuration.links.link1]: "Distance Sales Agreement",
        [configuration.links.link2]:
          "Service and Risk Acceptance Agreement",
      },
    },
  };

  const locale = Shopify?.locale || "en";
  const localeConfig = translations[locale];

  if (localeConfig) {
    param[messageKey] = localeConfig[messageKey];
    param[errorKey] = localeConfig[errorKey];
    Object.entries(localeConfig.labels).forEach(([key, label]) => {
      if (param.links[key]) param.links[key].label = label;
    });
  }

  window.roarJs.LegalConfig.metafields.settings.param = param;

  document
    .querySelectorAll(configuration.widgetSelector)
    .forEach((el) => el.remove());
  window.roarJs.Legal.init();
});
